<template>
  <div
    class="w-48 h-48 rounded border m-2 border-grey-600 bg-grey-900 relative gp-image-uploader "
  >
    <label v-if="file" for="file">
      <div  class="td-image-thumb" :style="{backgroundImage: 'url(' + file.thumb + ')'}">  
        <loader dark transparent :label="$t('frontend_uploading_image')"></loader>
      </div>
    </label>
    <div
      v-else
      class="flex absolute inset-0 text-grey-500 text-sm items-center justify-center pointer-events-none"
    >
      <div class="flex flex-col">
        <span class="flex justify-center mb-2"><image-icon></image-icon></span>
        <span>{{ $t('frontend_images_upload_image') }}</span>
      </div>
    </div>
    <file-upload
      extensions="gif,jpg,jpeg,png,webp"
      accept="image/png,image/gif,image/jpeg,image/webp"
      ref="file"
      name="file"
      post-action="/post.method"
      put-action="/put.method"
      @input-filter="inputFilter"
    />
  </div>
</template>
<script>
import ImageIcon from '../../assets/image-icon.svg';
import 'cropperjs/dist/cropper.css';
import Cropper from 'cropperjs';
import FileUpload from 'vue-upload-component';
import api from '@groovepages/gd-lib/api';
import Loader from '../Loader';


export default {
  components: {
    ImageIcon,
    FileUpload,
    Loader
  },
  props: {
    path: {
      default: 'me',
    },
  },
  data() {
    return {
      hasImage: false,
      file: undefined,
      cropper: false,
      editing: false,
      loading: false,
    };
  },
  watch: {
    editing: function (value, oldValue) {
      if (value) {
        this.$nextTick(function () {
          if (!this.$refs.editImage) {
            return;
          }
          this.cropper =  new Cropper(this.$refs.editImage, {
            viewMode: 1,
          });
        });
      } else {
        if (this.cropper) {
          this.cropper.destroy();
          this.cropper = false;
        }
      }
    }
  },
  methods: {
    cancel() {
      this.editing = false;
      this.$refs.editImage.clear;
    },
    remove() {
      this.file = undefined;
    },
    async upload() {
      if (this.loading) return;
      const file = new FormData();
      file.append('file', this.file,this.file.name.replace(/[^a-zA-Z0-9.-]/g, ""));
      this.loading = true;
      try {
        const result = await api.api('post', `${ window.gdEnv.VUE_APP_API_URL }/groovedigital/images/upload/${ this.path }`, file, true);
        this.$emit('add', result);
      } catch (err) {
        console.error(err);
      } finally {
        this.file = undefined;
        this.editing = false;
        this.loading = false;
      }
    },
    edit()
    {
      this.editing = true;
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (!/\.(gif|jpg|jpeg|png|webp)$/i.test(newFile.name)) {
          this.alert('Your choice is not a picture');
          return prevent();
        }
      }
      let file = newFile.file;
      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
         file.url = '';
        let URL = window.URL || window.webkitURL;
        if (URL && URL.createObjectURL) {
          file.url = URL.createObjectURL(newFile.file);
        }
      }

      file.thumb = '';
      const URL = window.URL || window.webkitURL;
      if (URL && URL.createObjectURL) {
        file.thumb = URL.createObjectURL(newFile.file);
      }
      this.file = file;
      this.upload();
    }
  }
};
</script>
<style>
.td-image-thumb{
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
  position: relative;
}
.btn-wrapper{
  position: absolute;
  left: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  color: red;
}
.btn-wrapper>button{
  margin: 10px;
}
.gp-image-uploader .slim {
  max-height: 192px !important;
}
.gp-image-uploader .slim-result {
  width: 192px !important;
  height: 192px !important;
}

.gp-image-uploader .slim-result img {
  object-fit: cover;
  width: 100% !important;
  height: 100% !important;
}
.btn-remove{
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 269 269' xmlns='http://www.w3.org/2000/svg' fill-rule='evenodd' clip-rule='evenodd' stroke-linejoin='round' stroke-miterlimit='1.414'%3E%3Cpath d='M63.12 250.254s3.998 18.222 24.582 18.222h93.072c20.583 0 24.582-18.222 24.582-18.222l18.374-178.66H44.746l18.373 178.66zM170.034 98.442a8.95 8.95 0 0 1 17.9 0l-8.95 134.238a8.95 8.95 0 0 1-17.9 0l8.95-134.238zm-44.746 0a8.949 8.949 0 1 1 17.898 0V232.68a8.95 8.95 0 1 1-17.9 0V98.442zm-35.798-8.95a8.95 8.95 0 0 1 8.95 8.95l8.95 134.237c0 4.942-4.008 8.948-8.95 8.948a8.95 8.95 0 0 1-8.95-8.95L80.54 98.441a8.95 8.95 0 0 1 8.95-8.95zm128.868-53.68h-39.376V17.898c0-13.578-4.39-17.9-17.898-17.9H107.39C95 0 89.492 6 89.492 17.9v17.91H50.116c-7.914 0-14.32 6.007-14.32 13.43 0 7.424 6.406 13.43 14.32 13.43H218.36c7.914 0 14.32-6.006 14.32-13.43 0-7.423-6.406-13.43-14.32-13.43zm-57.274 0H107.39l.002-17.914h53.695V35.81z' fill='%23fff'/%3E%3C/svg%3E")
}

.btn-edit{
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 269 269' xmlns='http://www.w3.org/2000/svg' fill-rule='evenodd' clip-rule='evenodd' stroke-linejoin='round' stroke-miterlimit='1.414'%3E%3Cpath d='M161.36 56.337c-7.042-7.05-18.46-7.05-25.5 0l-6.373 6.38-89.243 89.338.023.023-2.812 2.82s-8.968 9.032-29.216 74.4c-.143.456-.284.91-.427 1.373-.36 1.172-.726 2.362-1.094 3.568a785.126 785.126 0 0 0-.988 3.25c-.28.922-.556 1.835-.84 2.778-.64 2.14-1.29 4.318-1.954 6.567-1.455 4.937-5.01 16.07-.99 20.1 3.87 3.882 15.12.467 20.043-.993a1275.615 1275.615 0 0 0 9.41-2.83c1.032-.314 2.058-.626 3.063-.935 1.27-.39 2.52-.775 3.75-1.157l1.09-.34c62.193-19.365 73.358-28.453 74.286-29.284l.01-.01.067-.06 2.88-2.886.192.193 89.244-89.336 6.373-6.382c7.04-7.048 7.04-18.476 0-25.525l-50.998-51.05zM103.4 219.782c-.08.053-.185.122-.297.193l-.21.133c-.076.047-.158.098-.245.15l-.243.148c-2.97 1.777-11.682 6.362-32.828 14.017-2.47.894-5.162 1.842-7.98 2.82l-30.06-30.092c.98-2.84 1.928-5.55 2.825-8.04 7.638-21.235 12.22-29.974 13.986-32.94l.12-.2c.063-.1.12-.196.175-.283l.126-.2c.07-.11.14-.217.192-.296l2.2-2.205 54.485 54.542-2.248 2.255zM263.35 56.337l-50.996-51.05c-7.04-7.048-18.456-7.048-25.498 0L174.108 18.05c-7.04 7.048-7.04 18.476 0 25.524l50.996 51.05c7.04 7.048 18.457 7.048 25.498 0l12.75-12.762c7.04-7.05 7.04-18.477 0-25.525z' fill='%23fff'/%3E%3C/svg%3E")
}

.btn-upload{
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width='243' height='269' viewBox='0 0 243 269' xmlns='http://www.w3.org/2000/svg'%3E%3Ctitle%3EDownload%3C/title%3E%3Cpath d='M219.943 223.73H22.533c-12.21 0-22.11 10.017-22.11 22.373 0 12.356 9.9 22.373 22.11 22.373h197.41c12.21 0 22.11-10.017 22.11-22.373 0-12.356-9.9-22.373-22.11-22.373zM104.88 6.696c4.035-4.04 9.216-6.147 14.492-6.508C119.998.135 120.6 0 121.238 0c.633 0 1.228.135 1.847.186 5.284.357 10.473 2.464 14.512 6.51l70.763 70.967c8.86 8.875 8.86 23.267 0 32.142-8.86 8.876-23.225 8.876-32.086 0L143.612 77.05v106.41c0 12.355-10.016 22.372-22.374 22.372-12.356 0-22.372-10.017-22.372-22.373V77.05l-32.662 32.755c-8.86 8.876-23.226 8.876-32.086 0-8.86-8.875-8.86-23.267 0-32.142L104.88 6.696z' fill='%23FFF' fill-rule='evenodd'/%3E%3C/svg%3E")
}
.file-uploads{
  width: 100%;
  height: 100%;
}
</style>
